export default __webpack_public_path__ + "static/media/ri_forbid-2-line.c80f300b.svg";